module.exports = __webpack_public_path__ + "static/img/bcg_k6.3b411c8a.png";